import { render, staticRenderFns } from "./BaseEchart.vue?vue&type=template&id=66ea24dc"
import script from "./BaseEchart.vue?vue&type=script&lang=js"
export * from "./BaseEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ea24dc')) {
      api.createRecord('66ea24dc', component.options)
    } else {
      api.reload('66ea24dc', component.options)
    }
    module.hot.accept("./BaseEchart.vue?vue&type=template&id=66ea24dc", function () {
      api.rerender('66ea24dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/distributionDataMonitoring/com/BaseEchart.vue"
export default component.exports